<script>
  import { eventBus } from '../../main';

  export default {
    name: 'Preview',
    props: {
      /** The currently selected frame variant */
      variant: {
        type: Object,
        required: true,
      },
      /** The currently selected letter style */
      letterStyle: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        letterCanvas: [],
        lineOfText: 1,
        textArray: [],
      };
    },
    watch: {
      letterStyle() {
        this.displayText(this.textArray);
      },
    },
    computed: {
      lineOfTextStyle() {
        /**
         * inline style customizations to ensure for every line of
         * text, the letter images are positioned well on the frame
         */
        let styles = [];
        if (this.lineOfText === 1) {
          styles.push({
            left: '2.4%',
            top: '27%',
            width: '95%',
          });
        }
        if (this.lineOfText === 2) {
          styles.push({
            left: '2.4%',
            top: '31%',
            width: '95%',
          });
          styles.push({
            left: '2.4%',
            top: '53%',
            width: '95%',
          });
        }
        if (this.lineOfText === 3) {
          styles.push({
            left: '2.4%',
            top: '22%',
            width: '95%',
          });
          styles.push({
            left: '2.4%',
            top: '42%',
            width: '95%',
          });
          styles.push({
            left: '2.4%',
            top: '63%',
            width: '95%',
          });
        }
        return styles;
      },
    },
    methods: {
      getProductByChar(char, array) {
        let product = null;
        let charProduct = array.filter(function (l) {
          return l.key === char;
        });
        if (charProduct.length) {
          product = charProduct[0];
        }
        return product;
      },
      displayText(textArray) {
        // on every change empty letter canvas
        this.letterCanvas = [];
        let filteredTextArray = [];

        // filter out only values that have at least a value in textArray
        filteredTextArray = textArray.filter(text => text !== '');
        this.lineOfText = filteredTextArray.length;

        filteredTextArray.forEach((string, index) => {
          let stringArr = string.split('');
          this.letterCanvas[index] = [];
          stringArr.forEach((charStr, i) => {
            let charProduct = this.getProductByChar(charStr, this.letterStyle.chars);

            if (charStr === ' ') {
              this.letterCanvas[index][i] = {
                el: 'span',
                class: 'letter-display__char m-space',
              };
            } else {
              if (charProduct) {
                this.letterCanvas[index][i] = {
                  el: 'img',
                  class: 'letter-display__char m-' + charProduct.class + ' m-' + charProduct.type,
                  src: charProduct.image,
                  alt: charProduct.key + ' character',
                };
              }
            }
          });
        });
      },
    },
    created() {
      // when component is created default TEXT" uppercase
      this.textArray = ['TEXT'];
      this.displayText(this.textArray);

      eventBus.$on('new-data', (data) => {
        // check if textArray is empty by filtering through
        let filteredTextArray = [];
        filteredTextArray = data.textArray.filter(text => text !== '');
        if (filteredTextArray.length === 0) {
          this.textArray = ['TEXT'];
          this.displayText(this.textArray);
        } else {
          this.textArray = data.textArray;
          this.displayText(this.textArray);
        }
      });
    },
  };
</script>

<template>
  <div class="product-view__display m-plate">
    <div class="letter-display--lp js-custom-plate__display-wrap" :style="{backgroundImage: 'url('+variant.image+')'}">
      <div
        v-for="(text, i) in lineOfText"
        :key="i"
        class="plate letter-display__inner js-custom-plate__display"
        :style="lineOfTextStyle[i]"
      >
        <span v-for="(char, j) in letterCanvas[i]" :key="j" :class="char.class">
          <img v-if="char.el === 'img'" :src="char.src" :alt="char.alt"/>
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .letter-display--lp {
    background-color: #ffffff;
  }
  .plate.letter-display__inner {
    height: 47%;
  }
</style>
